import React from 'react';
import styled from 'styled-components';

import { spaceS, xdlColorText } from '@xingternal/tokens';

import { CompanyKununuData } from '@/graphql/generated';
import { appendQueryParams } from '@/helpers/query-string';

type Props = {
  companyProfileUrl?: CompanyKununuData['companyProfileUrl'];
  className?: string;
  onClick?: () => void;
};

const AnchorLink = styled.a`
  margin-bottom: ${spaceS};
  && {
    text-decoration: none;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: ${xdlColorText};
`;

export const KununuLink: React.FC<Props> = ({ children, className, companyProfileUrl, onClick }) =>
  companyProfileUrl ? (
    // eslint-disable-next-line react/jsx-no-target-blank
    <AnchorLink
      href={appendQueryParams(companyProfileUrl, {
        utm_source: 'xing_jobs',
        utm_medium: 'affiliate',
        utm_content: 'cta_score_profile',
        rfr: 'xjp_cta_score_profile',
      })}
      className={className}
      data-testid="kununu-company-profile-anchor"
      target="_blank"
      onClick={onClick}
    >
      <Wrapper>{children}</Wrapper>
    </AnchorLink>
  ) : (
    <div className={className} data-testid="kununu-company-profile-anchor">
      <Wrapper>{children}</Wrapper>
    </div>
  );
